module.exports = __webpack_public_path__ + "static/media/pc3.1246c9b7.webp";